<template>
    <rkm-overlay>
        <rkm-layout-body title="Confirmação de Exames de Imagem">
            <rkm-layout-content>
                <List />
            </rkm-layout-content>
        </rkm-layout-body>
    </rkm-overlay>
</template>

<script>
import List from '@/components/exame-imagem/confirmacao-exame/List'

export default {
    components: { List },
}
</script>
